import React from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import { SelectInput } from 'components/forms';

export default class extends React.Component {
    static propTypes = {
        name: React.PropTypes.string.isRequired,
        open: React.PropTypes.bool.isRequired,
        onToggle: React.PropTypes.func.isRequired,
        onChange: React.PropTypes.func.isRequired,
        value: React.PropTypes.string,
    };

    onToggle = () => {
        this.props.onToggle(this.props.name);
    };

    onChange = ({ value }) => {
        this.props.onChange(this.props.name, value);
    };

    render() {
        return (
            <div className="search-filter">
                <div className="search-filter__header">
                    <span className="search-filter__title">Type of Venue</span>
                    {this.props.open && <span className="search-filter__toggle search-filter__toggle--opened" onClick={this.onToggle}>X</span>}
                    {!this.props.open && <span className="search-filter__toggle search-filter__toggle--closed" onClick={this.onToggle}>+</span>}
                </div>

                <Collapse in={this.props.open}>
                    <div className="search-filter__filter">
                        <SelectInput
                            value={this.props.value}
                            onChange={this.onChange}
                            options={[{
                                value: 'Studios and galleries',
                                label: 'Studios and galleries',
                            }, {
                                value: 'Lofts and warehouses',
                                label: 'Lofts and warehouses',
                            }, {
                                value: 'Cultural institutions',
                                label: 'Cultural institutions',
                            }, {
                                value: 'Residential spaces',
                                label: 'Residential spaces',
                            }, {
                                value: 'Event halls and ballrooms',
                                label: 'Event halls and ballrooms',
                            }, {
                                value: 'Office/coworking spaces',
                                label: 'Office/coworking spaces',
                            }, {
                                value: 'Restaurants and bars',
                                label: 'Restaurants and bars',
                            }, {
                                value: 'Hotels and conference centers',
                                label: 'Hotels and conference centers',
                            }, {
                                value: 'Lounges and nightclubs',
                                label: 'Lounges and nightclubs',
                            }, {
                                value: 'Private Club',
                                label: 'Private clubs',
                            }, {
                                value: 'Other',
                                label: 'Other',
                            }]}
                        />
                    </div>
                </Collapse>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/VenueSearch/VenueTypeFilter.jsx